export const reportConversion = (transactionId) => {
  if (typeof window.gtag !== "function") return; // blocked by ad blocker, etc.
  window.gtag("event", "conversion", {
    send_to: "AW-18413346289/mJgsCKCJ4ugcEPG7lcxE",
    value: 1.0,
    currency: "INR",
    transaction_id: transactionId, // prevents double-counting
  });
};